import React from "react";
import { errorDialogDevelopmentMode } from "../../config/featureConfig";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Divider,
  Typography,
} from "@mui/material";
import { ErrorOutline } from "@mui/icons-material";

function safeStringify(value) {
  if (value === undefined) return "";
  try {
    return typeof value === "string" ? value : JSON.stringify(value, null, 2);
  } catch {
    return String(value);
  }
}

const ErrorDialog = ({ open, onClose, error, isDevelop = errorDialogDevelopmentMode}) => {
  if (!error) return null;

  const kind = error?.kind ?? error?.error?.kind ?? "UNKNOWN";
  const status = error?.status ?? error?.error?.status ?? null;
  const message = error?.message ?? error?.error?.message ?? "Si e verificato un errore";
  const developerDetail = error?.developerDetail ?? error?.error?.developerDetail ?? null;
  const data = error?.data ?? error?.error?.data;
  const raw = error?.raw ?? error?.error?.raw;
  const stack = error?.stack ?? error?.error?.stack ?? null;
  const debugPayload = raw ?? data ?? null;
  const showRawStackDump = debugPayload != null || stack != null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: "20px",
          overflow: "hidden",
        },
      }}
    >
      <DialogContent sx={{ p: 0 }}>
        <Box sx={{ p: 3, textAlign: "center" }}>
          <Box
            sx={{
              width: 80,
              height: 80,
              mx: "auto",
              mb: 2,
              borderRadius: "50%",
              backgroundColor: "#e00036",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <ErrorOutline sx={{ color: "white", fontSize: 48 }} />
          </Box>

          <Typography sx={{ fontFamily: "Rubik", fontWeight: 700, color: "#0b3d87", fontSize: 26 }}>
            Errore
          </Typography>
          <Typography sx={{ fontFamily: "Rubik", color: "#0b3d87", mt: 1, fontSize: 16 }}>
            {message || "Si e verificato un errore durante l'operazione."}
          </Typography>

          {isDevelop && developerDetail ? (
            <Box sx={{ mt: 2, textAlign: "left" }}>
              <Typography sx={{ fontFamily: "Rubik", fontWeight: 700, color: "#0b3d87", mb: 0.5 }}>
                Dettaglio (solo ambiente locale)
              </Typography>
              <Typography
                sx={{
                  fontFamily: "Rubik",
                  color: "#4f5d73",
                  fontSize: 14,
                  whiteSpace: "pre-wrap",
                  wordBreak: "break-word",
                }}
              >
                {developerDetail}
              </Typography>
            </Box>
          ) : null}

          {isDevelop && showRawStackDump ? (
            <Box sx={{ mt: 2, textAlign: "left" }}>
              {debugPayload != null ? (
                <>
                  <Typography sx={{ fontFamily: "Rubik", fontWeight: 700, color: "#0b3d87", mb: 1 }}>
                    Raw
                  </Typography>
                  <Box
                    sx={{
                      border: "1px solid #d7e3f2",
                      borderRadius: "10px",
                      p: 1.5,
                      backgroundColor: "#f8fbff",
                    }}
                  >
                    <pre style={{ margin: 0, whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                      {safeStringify(debugPayload)}
                    </pre>
                  </Box>
                </>
              ) : null}

              <Typography sx={{ fontFamily: "Rubik", fontWeight: 700, color: "#0b3d87", mt: 2, mb: 1 }}>
                Stack
              </Typography>
              <Box
                sx={{
                  border: "1px solid #d7e3f2",
                  borderRadius: "10px",
                  p: 1.5,
                  backgroundColor: "#f8fbff",
                }}
              >
                <pre style={{ margin: 0, whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                  {safeStringify(stack ?? `kind=${kind}${status ? ` status=${status}` : ""}`)}
                </pre>
              </Box>
            </Box>
          ) : null}
        </Box>

        <Divider />
        <DialogActions sx={{ p: 2, justifyContent: "center" }}>
          <Button
            onClick={onClose}
            sx={{
              fontFamily: "Rubik",
              backgroundColor: "#0b3d87",
              color: "white",
              fontWeight: "bold",
              borderRadius: "20px",
              px: 4,
              "&:hover": { backgroundColor: "#092b6a" },
            }}
          >
            OK
          </Button>
        </DialogActions>
      </DialogContent>
    </Dialog>
  );
};

export default ErrorDialog;

